import { render } from "./EvaluacionesUniformes.vue?vue&type=template&id=37657be8&scoped=true"
import script from "./EvaluacionesUniformes.vue?vue&type=script&lang=js"
export * from "./EvaluacionesUniformes.vue?vue&type=script&lang=js"

import "./EvaluacionesUniformes.vue?vue&type=style&index=0&id=37657be8&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37657be8"]])

export default __exports__